import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { NotificationService } from '../../../shared/notification.service';
import { CaseAsset } from '../case-asset';
import { CaseAssetService } from '../case-asset.service';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-case-asset-list',
  templateUrl: 'list.component.html',
  styleUrls: ['list.component.css'],
})
export class CaseAssetListComponent implements OnInit {
  @Input() caseRefreshed: EventEmitter<string>;

  @Input() caseId: string;

  public caseAssets: CaseAsset[] = [];

  public isLoading: boolean = true;

  public totalPages: number = 1;

  public currentPage: number = 1;

  public totalResults: number = 0;

  public itemDeleted: EventEmitter<boolean> = new EventEmitter<boolean>();

  public assetCreated: EventEmitter<boolean> = new EventEmitter<boolean>();

  public newAsset: CaseAsset = new CaseAsset();

  public editorOptions = {
    placeholder: 'Enter your note...',
    modules: {
      toolbar: ['bold', 'link'],
    },
  };

  constructor(
    private caseAssetService: CaseAssetService,
    private notificationService: NotificationService,
    public readonly authService: AuthService,
  ) {
    this.caseAssetService.loading.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
    this.caseAssetService.totalPages.subscribe(totalPages => {
      this.totalPages = totalPages;
    });
    this.caseAssetService.currentPage.subscribe(currentPage => {
      this.currentPage = currentPage;
    });
    this.caseAssetService.totalResults.subscribe(totalResults => {
      this.totalResults = totalResults;
    });
  }

  public ngOnInit(): void {
    this.loadCaseAssets(1);
    this.caseRefreshed.subscribe(id => {
      this.caseId = id;
      this.onPageChanged(1);
    });
  }

  public onPageChanged(pageNumber: number): void {
    this.loadCaseAssets(pageNumber);
  }

  public loadCaseAssets(page?: number, limit?: number): void {
    const listCountries = this.caseAssetService
      .listCaseAssets(page, limit, { parameters: { id: this.caseId } })
      .subscribe((caseAssets: CaseAsset[]) => {
        this.caseAssets = caseAssets;
        listCountries.unsubscribe();
      });
  }

  public create(formData: CaseAsset) {
    this.caseAssetService
      .createCaseAsset(this.newAsset, { parameters: { id: this.caseId } })
      .subscribe(results => {
        this.assetCreated.next(true);
        this.onPageChanged(1);
      });
    console.log('creating', this.newAsset);
  }

  public delete(id: string) {
    this.caseAssetService.deleteCaseAsset(id).subscribe(
      deleted => {
        this.notificationService.success(
          `Asset Deleted`,
          `Vehicle with ID ${id} was deleted.`,
          5,
        );
        this.itemDeleted.next(true);
        this.onPageChanged(this.currentPage);
      },
      err => {
        this.notificationService.error(
          `Asset Not Deleted`,
          err.error.message,
          10,
        );
        this.itemDeleted.next(false);
        this.onPageChanged(this.currentPage);
      },
    );
  }
}
